module.exports = __webpack_public_path__ + "img/editing.66a43e3e.png";